import { render, staticRenderFns } from "./SummaryOverview.vue?vue&type=template&id=24743a89&"
import script from "./SummaryOverview.vue?vue&type=script&lang=ts&"
export * from "./SummaryOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports